import { Component, EventEmitter, Input, OnInit, Output, TemplateRef, ViewChild } from '@angular/core';
import { Address, Client, Email, Information, Telephone } from '../../../../models/client';
import { GlobalConfig, ToastrService } from 'ngx-toastr';
import { NgbModal, NgbModalOptions, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { ClientService } from '../../../../services/Client/client.service';
import { AuthenticationService } from '../../../../auth/service';

@Component({
    selector: 'app-add-client-modal',
    templateUrl: './add-client-modal.component.html',
    styleUrls: ['./add-client-modal.component.scss']
})
export class AddClientModalComponent implements OnInit {
    @Input() clientId!: number;
    @Input() stationId!: number;
    @Output() clientSaved = new EventEmitter<Client>();
    @ViewChild('modalLG') modalTemplate?: TemplateRef<any>;
    private options: GlobalConfig;
    modalRef: NgbModalRef | null = null;

    client: Partial<Client> = {
        civilite: '',
        identifiant_unique: '',
        nom_entreprise: '',
        type: '',
        is_archive: false,
        nom_prenom: '',
        station_id: 0,
        user_id: 0,
        emails: [],
        telephones: [],
        adresses: [],
        informations: []
    };

    constructor(
        private toastr: ToastrService,
        private modalService: NgbModal,
        private clientService: ClientService,
        private authService: AuthenticationService
    ) {
        this.options = this.toastr.toastrConfig;
    }

    ngOnInit(): void {
        this.client.station_id = this.stationId;
        this.client.user_id = this.authService.currentUserValue?.id || 0;
    }

    openModal(): void {
        this.resetForm();
        const options: NgbModalOptions = {
            centered: true,
            backdrop: 'static',
            keyboard: true,
            size: 'lg'
        };
        this.modalRef = this.modalService.open(this.modalTemplate, options);
    }

    selectClientType(type: 'Individuel' | 'Professionnel'): void {
        this.client.type = type;
    }


    get isFormValid(): boolean {
        const base = !!(this.client.civilite && this.client.nom_prenom?.trim() && this.client.type);
        if (this.client.type === 'Professionnel') {
            return base && !!(this.client.nom_entreprise?.trim());
        }
        return base;
    }

    onSubmit(): void {
        if (!this.isFormValid) {
            this.toastr.error('Veuillez remplir tous les champs obligatoires.', 'Erreur');
            return;
        }

        const payload = {
            civilite: this.client.civilite,
            type: this.client.type,
            nom_prenom: this.client.nom_prenom?.trim(),
            identifiant_unique: this.client.identifiant_unique?.trim(),
            nom_entreprise: this.client.nom_entreprise?.trim() || null,
            station_id: this.stationId,
            user_id: this.authService.currentUserValue?.id || 0,
            emails: this.client.emails || [],
            telephones: this.client.telephones || [],
            adresses: this.client.adresses || [],
            is_archive: false
        };

        this.clientService.addClient(payload as Client).subscribe({
            next: (newClient) => {
                this.modalRef?.close();
                this.clientSaved.emit(newClient);
                this.toastr.success('Client ajouté avec succès !', '', {
                    positionClass: 'toast-top-right',
                    toastClass: 'toast ngx-toastr custom-success-toast'
                });
                this.resetForm();
            },
            error: (err) => {
                this.toastr.error('Erreur lors de l’ajout du client', err.message || 'Erreur inconnue');
            }
        });
    }

    private resetForm(): void {
        this.client = {
            civilite: '',
            type: '',
            nom_prenom: '',
            identifiant_unique: '',
            nom_entreprise: '',
            station_id: this.stationId,
            user_id: this.authService.currentUserValue?.id || 0,
            emails: [],
            telephones: [],
            adresses: [],
            is_archive: false,
            informations: []
        };
    }
}
